module.exports = __webpack_public_path__ + "img/saint-john-the-apostle.59d7843d.jpg";